import type { UserRole, UserStatus } from '@psp-aggregator/sdk';
import sdk from '@psp-aggregator/sdk';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const invalidateUsers = (
  queryClient: ReturnType<typeof useQueryClient>,
): void => {
  void queryClient.invalidateQueries({ queryKey: ['listUsers'] });
  void queryClient.invalidateQueries({ queryKey: ['listRegistrationInvites'] });
};

export const useAssignUserRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      role,
      userId,
    }: {
      role: UserRole;
      userId: string;
    }): Promise<void> => {
      await sdk.requests.setUserRole({ role }, userId);
      await sdk.requests.setUserStatus({ status: 'active' }, userId);
    },
    onSuccess: () => {
      invalidateUsers(queryClient);
    },
  });
};

export const useChangeUserRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      role,
      userId,
    }: {
      role: UserRole;
      userId: string;
    }): Promise<unknown> => sdk.requests.setUserRole({ role }, userId),
    onSuccess: () => {
      invalidateUsers(queryClient);
    },
  });
};

export const useSetUserStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      reason,
      status,
      userId,
    }: {
      reason?: string;
      status: UserStatus;
      userId: string;
    }): Promise<unknown> =>
      sdk.requests.setUserStatus({ reason, status }, userId),
    onSuccess: () => {
      invalidateUsers(queryClient);
    },
  });
};
